import type { TFunction } from 'i18next';

/**
 * Shared "time ago" formatter used across the admin surfaces (Service/Sports
 * health, Spending, Logs, playback health, resolve cache). Routes every copy of
 * the previously-duplicated `formatRelative` through the `common.relativeTime.*`
 * keys so the English wording stays identical while Spanish is translated once.
 */
export function formatRelativeTime(t: TFunction, iso: string | null, nowMs: number): string {
  if (!iso) return t('common.relativeTime.never');
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return t('common.relativeTime.never');
  const diff = Math.max(0, nowMs - then);
  if (diff < 60_000) return t('common.relativeTime.justNow');
  const mins = Math.round(diff / 60_000);
  if (mins < 60) return t('common.relativeTime.minAgo', { count: mins });
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return t('common.relativeTime.hrAgo', { count: hrs });
  const days = Math.round(hrs / 24);
  return t('common.relativeTime.dayAgo', { count: days });
}
